export default function Navbar({ children }) {
	return <ul className="site-menu-main">{children}</ul>;
}
